import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { urls } from '@adex/shared/network/urls'
import { CustomHttpClient } from '@adex/shared/network/custom-http-client'
import { NotificationType } from '@adex/shared/models/inside-models/notification'


@Injectable()
export class NotificationNetworkService {

  constructor(private readonly http: CustomHttpClient) {
  }

  public getNotificationsList(): Observable<NotificationType[]> {
    return this.http.get<NotificationType[]>(urls.notifications.list)
  }

  public createNotification(notification: NotificationType): Observable<void> {
    return this.http.post<void, NotificationType>(urls.notifications.create, { ...notification })
  }

  public editNotification(notification: NotificationType): Observable<void> {
    return this.http.post<void, NotificationType>(urls.notifications.update, { ...notification })
  }

  public deleteNotification(id: number): Observable<void> {
    return this.http.get(urls.notifications.delete(id))
  }
}
